<template>
  <section class="section background-black is-medium">
    <div class="container">
      <!-- Main container -->
      <nav class="level">
        <!-- Left side -->
        <div class="level-left">
          <div class="level-item">
            <span class="title is-2 is-capitalized has-text-light">Our programs</span>
          </div>
          <div class="level-item">
            <Whatsapp />
          </div>
        </div>

        <!-- Right side -->
        <div class="level-right"></div>
      </nav>

      <!-- scrolling program menu -->
      <h1 class="title is-4 heading-line has-text-weight-bold has-text-light">Choose a class</h1>
      <div class="columns scrolling-wrapper">
        <div
          class="column card drop-shadow"
          v-for="(program, index) in programs"
          :key="index"
          :style="{ backgroundImage: 'url(' + program.img + ')' }"
        >
          <div class="gradient">
            <span v-if="program.popular" class="popular"></span>

            <div class="block">
              <h2 class="is-uppercase has-text-weight-bold">{{ program.name }}</h2>
              <p class="is-size-7 paragraph">{{ program.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Whatsapp from "./Whatsapp.vue";
export default {
  data() {
    return {
      programs: [
        {
          name: "Boxing",
          desc: "Learn Basics of Boxing in 60 days",
          popular: true,
          img: require("@/assets/classes/boxing.jpg")
        },
        {
          name: "Kick Boxing",
          desc: "Start Boxing asap",
          img: require("@/assets/classes/kickboxing.jpg")
        },
        {
          name: "Muay Thai",
          desc: "Start Boxing asap",
          img: require("@/assets/classes/muaythai.jpg")
        },
        {
          name: "MMA 101",
          desc: "MMA Introduction",
          img: require("@/assets/classes/mma.jpg")
        },
        {
          name: "Self Defense",
          desc: "Start Boxing asap",
          img: require("@/assets/classes/selfdefense.jpg")
        },
        {
          name: "Functional Fitness",
          desc: "Start Boxing asap",
          img: require("@/assets/classes/functional.jpg")
        }
      ]
    };
  },
  components: {
    Whatsapp
  }
};
</script>

<style lang="scss" scoped>
.card {
  background-position: cover;
  background-repeat: no-repeat;
  border-radius: 5px;
}

.popular {
  position: absolute;
  top: -10px;
  right: -15px;
  background-color: red;
  color: black;
  border-radius: 200008908px;
  padding: 5px;
  font-size: 0.55rem;
  text-transform: uppercase;
  font-family: Open Sans, Open Sans Hebrew, Arial;
  font-weight: 700;
}

.popular:after {
  content: "most popular";
}

.heading-line {
  position: relative;
  padding-bottom: 20px;
}

.section-title.heading-line {
  padding-bottom: 14px;
}

.heading-line:after {
  content: "";
  position: absolute;
  bottom: 0px;
  height: 5px;
  left: 0px;
  width: 69px;
  background: red;
}

.highlight:after {
  width: 20px;
  border-bottom: 5px solid red;
}

.background-black {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgb(10, 10, 10) 47%,
    rgb(13, 13, 13) 100%
  );
}

.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  .card {
    flex: 0 0 auto;
    padding: 20px;
    margin: 10px;
    height: 200px;
    width: 145px;
    background-color: #131313;
    color: whitesmoke;
  }
}

.card {
  display: inline-block;
  padding: 20px;
  margin: 10px;
  height: 200px;
  width: 145px !important;
  background-color: #131313;
  color: whitesmoke;
}

.scrolling-wrapper {
  -webkit-overflow-scrolling: touch;
}

.scrolling-wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}

.icon {
  vertical-align: middle;
}

.gradient {
  background: linear-gradient(rgba(10, 10, 10, 0.5), rgba(0, 0, 0, 0.5));
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  border-radius: 5px;
  word-wrap: break-word;
}
</style>
